import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { formatDataTest } from '~/utils';
import { DetailAction } from '~/components';
import { triggerEditPageClickedAnalytics } from '~/analytics/analytics.listener';

import styles from './Section.scss';

export class Section extends PureComponent {
  onClickHandler = () => {
    const {
      editPath,
      history,
      analyticsSectionType,
      matchParams: { appointmentId },
    } = this.props;
    triggerEditPageClickedAnalytics(analyticsSectionType);
    history.pushWithToken(`${appointmentId || ''}${editPath}`);
  };

  render() {
    const { category, selectorName, children, showEditButton, isNotDescriptionListContent } =
      this.props;

    return (
      <div className={styles.Section} data-testid={formatDataTest(selectorName || category)}>
        <div className={styles.Section__header}>
          <h3 className={styles.Section__title}>{category}</h3>
          {showEditButton && <DetailAction onClick={this.onClickHandler} />}
        </div>
        {isNotDescriptionListContent ? (
          <>{children}</>
        ) : (
          <dl className={styles.Section__question_list}>{children}</dl>
        )}
      </div>
    );
  }
}

Section.propTypes = {
  history: PropTypes.shape({}).isRequired,
  matchParams: PropTypes.shape({}),
  analyticsSectionType: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  editPath: PropTypes.string.isRequired,
  showEditButton: PropTypes.bool,
  selectorName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isNotDescriptionListContent: PropTypes.bool,
};

Section.defaultProps = {
  children: null,
  selectorName: '',
  showEditButton: true,
  matchParams: {},
  isNotDescriptionListContent: false,
};
